define(["underscore", "utils/keys", "utils/dom", "utils/mustache", "utils/trace"], function(_, keys, dom, Mustache, Trace) {
  function actionEventIsAlreadyHandled(e) {
    return e.originalEvent && e.originalEvent.mindbreezeActionHandled;
  }

  function setActionEventAsHandled(e) {
    if (!e.originalEvent) return;
    e.originalEvent.mindbreezeActionHandled = true;
  }

  function actionEventIsMouseDownEvent(event) {
    return event.type === "mousedown";
  }

  function mouseDownEventIsMiddleButtonEvent(event) {
    return event.button === 1;
  }

  function mouseDownEventIsRightClickEvent(event) {
    return event.which === 3;
  }

  function handleActionObjectCall(args, actionName, target, focused, traceContext, e, options, model, base) {
    return options.application.handleAction(
      args,
      actionName,
      target,
      getActionModel(e, model),
      base,
      focused,
      traceContext,
      e
    );
  }

  function getActionModel(e, model) {
    return model;
  }


  function handleActionInstrumented(e, application, model, focusElement, targetEl) {

    let method = (e, traceContext) => {
      return handleAction(e, traceContext, this, {application}, model, focusElement, targetEl);
    }
    // based on Backbone.View
    // events: { "click *.action": "handleAction" }

    function paramaterCallback(e) {
      var parameters = ["handleAction"];
      if (e && e.target) {
        parameters.push(e.target.className);
      }
      return parameters;
    }
    
    const instrumentedMethod = Trace.instrument(method, "uiAction", paramaterCallback );
    return instrumentedMethod(e);
  }

  
  function handleAction(e, traceContext, base, options, model, focusElement, targetEl) {
    var eventType = e.currentTarget.getAttribute("data-event-mask") || "keypress|click|mousedown";
    if (e.currentTarget.disabled === true) {
      return true;
    }
    if (!new RegExp(eventType).test(e.type)) {
      return true;
    }
    if (
      e &&
      "keypress" === e.type &&
      (e.which !== keys.enter && !(e.which === keys.space && /button/i.test(e.currentTarget.getAttribute("role"))))
    ) {
      return true;
    }

    // Handle middle- and rightclick actions
    if (actionEventIsMouseDownEvent(e)) {
      if (mouseDownEventIsMiddleButtonEvent(e)) {
        e.preventDefault();
      } else if (mouseDownEventIsRightClickEvent(e)) {
        // Do not trigger the main action for right clicks but trigger beforeactionperformed and actionperformed
        e.ignoreActionExecution = true;
        e.preventDefault();
      } else {
        return true;
      }
    }

    if (options.application && _.isFunction(options.application.closeMenus)) {
      options.application.closeMenus();
    }

    if (actionEventIsAlreadyHandled(e)) return true;

    var target = targetEl || e.currentTarget;
    var stopEvent = !/checkbox|radio/i.test(target.type);
    var result = undefined;

    var actionObject = target.getAttribute("data-action-object");
    var actionName = target.getAttribute("data-action-name");

    var action = target.getAttribute("data-action");
    var key = target.getAttribute("data-name");
    var addKey = target.getAttribute("data-add");
    var unsetKey = target.getAttribute("data-unset");
    var value = target.getAttribute("data-value");
    var ref = target.getAttribute("data-ref");
    var href = target.getAttribute("href");
    var handled = false;

    var expandableAttrs = new dom.AttributeModel(target, "$data-").getCamelCase();
    var that = base;
    var exprEnvironment = options.application.exprEnvironment;
    var bindings = (exprEnvironment && exprEnvironment.getBindings()) || {};

    var dataAttr = _.reduce(
      _.keys(expandableAttrs),
      function(attrs, key) {
        // remove the $
        key = key.substring(1);
        var value = Mustache.render(expandableAttrs[key], bindings);
        attrs[key] = value;
        return attrs;
      },
      {}
    );

    dataAttr = _.extend(dataAttr, new dom.AttributeModel(target, "data-").getCamelCase());
    if (dataAttr.actionName) {
      delete dataAttr.actionName;
    }

    if (!value && /^select$/i.test(target.tagName)) value = target.value;
    if (!value && /checkbox|radio/i.test(target.type)) value = target.checked;

    var focused = focusElement;

    if (
      actionObject &&
      e &&
      e.handleObj &&
      e.handleObj.selector &&
      !e.handleObj.selector.match(/.*\[data-action-object\]/)
    )
      return !stopEvent;

    // TODO: schema on model?
    try {
      value = JSON.parse(value);
    } catch (e) {}

    if (ref) {
      value = getActionModel(e, model).output.get(ref);
    }
    if (!actionObject) {
      if (actionName) {
        actionObject = {};
        actionObject[actionName] = dataAttr;
      } else if (key) {
        actionObject = {
          setValue: {
            key: key,
            value: value
          }
        };
      } else if (addKey) {
        actionObject = {
          addValue: {
            key: addKey,
            value: value
          }
        };
      } else if (unsetKey) {
        actionObject = {
          unsetValue: {
            key: unsetKey
          }
        };
      } else if (action) {
        handled = true;
        var handleFunction = new Function("application", "view", action);
        try {
          // base == this
          handleFunction.apply(getActionModel(e, model), [options.application, base]);
        } catch (e) {
          console.error("Failed to execute action", JSON.stringify(action), e);
        }
      } else if (href) {
        actionObject = {
          openHref: {
            href: href
          }
        };
      }
    }

    if (actionObject) {
      handled = true;
      if (/string/i.test(typeof actionObject)) {
        actionObject = JSON.parse(actionObject);
      }
      try {
        _.forEach(
          actionObject,
          _.bind(function(args, actionName) {
            var returnValue = handleActionObjectCall(args, actionName, target, focused, traceContext, e, options, model, base);
            if (result !== false) {
              result = returnValue;
            }
          }, base)
        );
        if (actionObject.stopPropagation) stopEvent = true;
      } catch (e) {
        console.error("Failed to execute action", actionObject, e.stack, e);
      }
    }

    if (handled) setActionEventAsHandled(e);

    if (handled && (typeof result === "undefined" || result === false)) {
      if (stopEvent && !e.enforceDefault) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }

  return  {
    handleAction : handleAction,
    handleActionObjectCall: handleActionObjectCall,
    handleActionInstrumented: handleActionInstrumented
  };
});


